module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.9fd014b6.webp";